export const environment = {
  production: true,
  gameUrl: './assets/games/ghibellina2021',
  nearby: 1000,
  gaMeasurementId: 'G-YMCHCDC2HF',
  privacy: {
    site: 'https://play.vivavoce.it',
    titolare: 'Associazione VivaVoce',
    mail: 'info@vivavoce.it'
  }  
};
